import { useEffect, useState } from 'react';
import axios from 'axios';
import './ManageNotifications.css';

export default function ManageNotifications() {
  const [notifications, setNotifications] = useState([]);
  const [form, setForm] = useState({
    title: '',
    description: '',
    url: '',
    image: null,
  });

  const [editId, setEditId] = useState(null);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 5;

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    const res = await axios.get(
      'https://spinelleapi.emedha.in/admin/advertise/api/notifications'
    );
    setNotifications(res.data);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setForm({ ...form, image: e.target.files[0] });
  };

  const submitNotification = async () => {
    const data = new FormData();
    Object.keys(form).forEach((key) => {
      if (form[key]) data.append(key, form[key]);
    });

    if (editId) {
      await axios.put(
        `https://spinelleapi.emedha.in/admin/advertise/api/notifications/${editId}`,
        data
      );
    } else {
      await axios.post(
        'https://spinelleapi.emedha.in/admin/advertise/api/notifications',
        data
      );
         alert('Notification sent successfully!');
    }

    resetForm();
    fetchNotifications();
  };

  const resetForm = () => {
    setForm({ title: '', description: '', url: '', image: null });
    setEditId(null);
  };

  const editNotification = (n) => {
    setEditId(n.id);
    setForm({
      title: n.title,
      description: n.description,
      url: n.url || '',
      image: null,
    });
  };

  const deleteNotification = async (id) => {
    await axios.delete(
      `https://spinelleapi.emedha.in/admin/advertise/api/notifications/${id}`
    );
    fetchNotifications();
  };

  // Pagination logic
  const start = (currentPage - 1) * perPage;
  const current = notifications.slice(start, start + perPage);
  const pages = Math.ceil(notifications.length / perPage);

  return (
    <div className="manage-container">
      <div className='form-container'>
      <h2>Manage Notifications</h2>

      <div className="form-group1">
        <input name="title" placeholder="Title" value={form.title} onChange={handleChange} />
      
        <input name="url" placeholder="URL (optional)" value={form.url} onChange={handleChange} />
        <input type="file" onChange={handleFileChange} />
          <textarea
          name="description"
          placeholder="Description"
          value={form.description}
          onChange={handleChange}
          style={{ gridColumn: "1 / 3" }}
        />
        <button onClick={submitNotification}>
          {editId ? 'Update Notification' : 'Send Notification'}
        </button>
        {editId && <button onClick={resetForm}>Cancel</button>}
      </div>
      </div>
{/* 
      <table className="category-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Title</th>
                   <th>Image</th>
            <th>URL</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {current.map((n, i) => (
            <tr key={n.id}>
              <td>{start + i + 1}</td>
              <td>{n.title}</td>
              
              <td>
                {n.image && <img src={n.image} alt="" width="60" />}
              </td>
                       <td>{n.url}</td>
              <td>
                <button className="edit-btn" onClick={() => editNotification(n)}>Edit</button>
                <button className="delete-btn" onClick={() => deleteNotification(n.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pagination">
        {[...Array(pages)].map((_, i) => (
          <button
            key={i}
            className={currentPage === i + 1 ? 'active' : ''}
            onClick={() => setCurrentPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}
      </div> */}
    </div>
  );
}
